import React from "react";
import cn from "classnames";

import styles from "./styles.module.scss";

export const ALIGN = {
    middle: "middle",
    end: "end",
    top: "top",
};

const FormRow = ({ children, withMargin, withSpace = true, withLine, align = ALIGN.end, fromTo = false }) => (
    <div
        className={cn(styles.row, styles[`row--${ALIGN[align]}`], {
            [styles["row--with-margin"]]: withMargin,
            [styles["row--with-children"]]: children.length,
            [styles["row--from-to"]]: fromTo,
        })}
    >
        {children.length
            ? children.map((child, index) => (
                  <div
                      key={index}
                      className={cn(styles.col, {
                          [styles["col--with-space"]]: withSpace,
                      })}
                  >
                      {child}
                  </div>
              ))
            : children}
        {withLine && <span className={styles.line} />}
    </div>
);

export default FormRow;
